<footer class="bg-light p-3">
  <div class="container">
    <div class="text-center text-white">
      Copyright &copy; Wide Eyes Technologies 2020
    </div>
  </div>
</footer>
